import { EMPTY_OBJECT } from '../../../constants/common'
import { SearchItem } from '../../Search'

import { BUILDING_SEARCH_ITEM_ICON } from './BuildingSearchItem.constants'

import * as styles from './BuildingSearchItem.module.css'

function BuildingSearchItem({ className = styles.BuildingSearchItem, value }) {
  const { address, archived } = value.item ?? EMPTY_OBJECT

  return (
    <SearchItem
      archived={archived}
      className={className}
      icon={BUILDING_SEARCH_ITEM_ICON}
      title={address}
    />
  )
}

export default BuildingSearchItem
